<template>
  <div class="lp-ingredients__container ingredients-modal">
    <div class="ingredients__title lp-natural__title" v-html="title"></div>
    <div class="ingredients-modal__carousel" id="ingredientsModalCarousel">
      <swiper
        :modules="modules"
        :loop="true"
        :looped-slides="ingredients.length"
        :breakpoints="breakpoints"
        @swiper="setSwiperRef"
        :pagination="{ dynamicBullets: true }"
      >
        <swiper-slide v-for="item in ingredients">
          <div class="ingredients-modal__card">
            <div class="ingredients-modal__image">
              <div class="ingredients-modal__badge" v-if="item.badgeUrl">
                <img :src="item.badgeUrl">
              </div>
              <img :src="item.imageUrl">
            </div>
            <div class="ingredients-modal__title" v-html="item.name"></div>
            <div class="ingredients-modal__text" v-html="item.description"></div>
            <div class="ingredients-modal__close" @click="close">
              <svg width="18.979095" height="18.978638" viewBox="0 0 18.9791 18.9786" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path id="Vector 57" d="M17.97 17.97L1 1" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
                <path id="Vector 58" d="M1 17.97L17.97 1" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
              </svg>
            </div>
          </div>
        </swiper-slide>
        <div  class="ingredients-modal__arrows">
          <button type="button" @click="swiperPrevSlide" class="prev">
            <svg width="11.242554" height="20.451172" viewBox="0 0 11.2426 20.4512" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path d="M1 10.19L10.19 1" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
              <path d="M10.23 19.44L1.04 10.25" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
            </svg>

          </button>
          <button type="button" @click="swiperNextSlide" class="next">
            <svg width="11.242554" height="20.451172" viewBox="0 0 11.2426 20.4512" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path d="M10.23 10.19L1.04 1" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
              <path d="M1 19.44L10.19 10.25" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </swiper>
    </div>
    <div class="ingredients-modal__close" @click="close">
      <svg width="18.979095" height="18.978638" viewBox="0 0 18.9791 18.9786" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path id="Vector 57" d="M17.97 17.97L1 1" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
        <path id="Vector 58" d="M1 17.97L17.97 1" stroke="#03666E" stroke-opacity="1.000000" stroke-width="2.000000" stroke-linecap="round"/>
      </svg>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, onMounted } from 'vue';
import { Navigation, Pagination } from "swiper";

const modules = [Navigation, Pagination];

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  ingredients: {
    type: Array,
    default: []
  },
  initialSlide: {
    type: Number,
    default: 0
  },
});

let swiperRef = ref(null);

const setSwiperRef = (swiper) => {
  swiperRef.value = swiper;
};

const swiperPrevSlide = () => {
  swiperRef.value.slidePrev()
}

const swiperNextSlide = () => {
  swiperRef.value.slideNext()
}

const emit = defineEmits(['close']);

const breakpoints = {
  320: {
    spaceBetween: 20,
  },
  768: {
    spaceBetween: 80,
  },
  1024: {
    spaceBetween: 138,
  },
}

const close = () => {
  emit('close', swiperRef.value.realIndex);
}

onMounted(() => {
  swiperRef.value.slideToLoop(props.initialSlide, 0);
  const rect = document.getElementById('ingredientsModalCarousel').getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const elementPosition = rect.top + scrollTop - document.getElementsByClassName('header__menu')[0].offsetHeight;
  window.scrollTo({
    top: elementPosition,
    behavior: "smooth",
  });
})

</script>
